import React from "react";

// Het balkje achter een bedrag. De breedte is het bedrag ten opzichte van de
// hoogste in dezelfde lijst; een minimum zorgt dat kleine bedragen zichtbaar
// blijven in plaats van te verdwijnen.
const BarTrack = ({ value, max, min = 4 }) => (
  <div className="track">
    <i style={{ width: `${max ? Math.max(min, (value / max) * 100) : 0}%` }} />
  </div>
);

export default BarTrack;
